 export const NavigationRoutes = {
LOGIN:'/login',
HEADERSETTINGS:'/content-settings',

VERIFIED_USER_LISTING:'/verified-user-listing',
CATEGORIES:'/categories',
SUB_CATEGORIES:'/categories/:id',
ATTRIBUTES:'/attributes/:id',
FORGOT_PASSWORD:'/forgot-password',
ADMIN_DASHBOARD:'/admin-dashboard',
CREATE_NEW_PASSWORD:"/create-new-password/:token",
USER_DETAILS:"/user-details/:id",
PLANS:'/plans',
VEHICLE:'/vehicle',
VEHICLE_MAKE:'/vehicle-make',
VEHICLE_MODEL:'/vehicle-make/:id',
BLOG:'/blog',
ADD_BLOG:'/add-blog',
EDIT_BLOG:'/add-blog/:id',
FAQS:'/faqs',
CONTACTUS:'/contact',
ADREPORTS:'/ad-reports',


 };